module.exports = __webpack_public_path__ + "static/media/natural-honey.3300ec42.jpg";